import React from "react";
import { motion } from "framer-motion";
import { pathVariants5 } from "../paths/pathVariants";

export const PaperStack = () => {
  return (
    <div className="svg-left">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 138.23 184.34">
        <g style={{ isolation: "isolate" }}>
          <g id="Layer_2" data-name="Layer 2">
            <g id="illustration">
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M100,86.86c-.41-.54-1-1.34-1.71-2.31-1-1.31-1.65-2.32-1.72-2.42-2.49-3.59-1.37-14.76-1.37-14.76.52-6.35,1.24-14.68,1.49-16.16l.2.48a5.7,5.7,0,0,0,2,1.89A21.79,21.79,0,0,1,101.69,55c1.64,1,4.55,6.95,6,15.64"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M100.27,168.35a15.14,15.14,0,0,1-.55,2.9h0c-.41,1.4-.92,2.44-1.2,3.65-.44,1.9-1,9.3-1,9.3H84.26a106.44,106.44,0,0,0,1.9-11.71c.73-6.55-3.18-29.11-3.52-31.05,0-.08,0-.13,0-.13-3.43,14.32-11.83,30.93-12.68,31.88a10.56,10.56,0,0,1-2.57,1.8c-1,1.81-3,9.21-3,9.21H49.12c.85-3.91,4.75-9.77,6-12s5.89-17.11,7.13-27c.52-4.12.91-8.47,1.2-12.15h0c.41-5.13.61-9,.61-9,3.89-4,34.35-7.92,34.35-7.92l1,3.13s1.09.23,1.24,1-.88,1.45-.88,1.45C103.14,141.19,100.55,165.22,100.27,168.35Z"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M129.59,86.71c.55,0,1.28.17,1.54.69l0,.06a1.87,1.87,0,0,1,.09,1.47c-.5,1.11-2.52,1.13-3.65.85a4,4,0,0,1-1.7-.89,1.6,1.6,0,0,1-.73-1,1.35,1.35,0,0,1,.39-.93,1.85,1.85,0,0,1,1-.61"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M39,64.51l.14.09a2.93,2.93,0,0,0,1.95.48c1.08-.19,2-1.84,2-1.84a1.49,1.49,0,0,1,.94.51,23.91,23.91,0,0,0,7-7c2.72-4.4,3.16-4.94,3.16-4.94a8.87,8.87,0,0,1,1.64-.46"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M36,75.34"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M57.47,81.56l-1-5.71s-2.67,0-6.56,3.62a11.21,11.21,0,0,1-1.43,4.4S44,86,41.87,89"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M82.41,62.16"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M69.59,36.27A15.88,15.88,0,0,1,69.88,38c.19,1.75.59,5.5-1.6,8.44a8.36,8.36,0,0,1-2.34,2.12"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M38.18,68A6.72,6.72,0,0,1,39,64.51l.14.09c3.69,2.41,5,9.48,5.25,14.74,0-1.33.88-6.5,1.52-6.4.82.13,2.22,9.63,2.22,9.63,1.64-8.15-3.22-17.34-3.64-18.12A28.46,28.46,0,0,1,49.74,78.2l7.54-5.51s4.54-4.57,3-12.43-4.37-8.92-4.37-8.92c.74-.14,1.75-2.15,2.59-2,.72-.05,13.45,22.4-1,32.18l-1-5.71s-2.67,0-6.56,3.62a11.21,11.21,0,0,1-1.43,4.4S44,86,41.87,89s-2.87,3.24-5,1.57"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
                opacity="0.83"
                style={{ mixBlendMode: "multiply" }}
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M36,75.34"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
                opacity="0.83"
                style={{ mixBlendMode: "multiply" }}
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M87.07,13.85c.6,3.1.63,6.38,1,7.44.58,1.65,2.6,3.61,3.18,5.83.52,2.05,0,13.42-2.36,16.31l0,.06a1.92,1.92,0,0,1-.57.48c-2.86,1.46-10.46,1.08-14.58-2.53A17.17,17.17,0,0,1,70,36.74v0c-.12-.28-.25-.55-.38-.83"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M85.72,9.81a13.16,13.16,0,0,1,1.35,4"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M85.34,9.21a6.1,6.1,0,0,1,.38.6"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M87.15,6.55a8.48,8.48,0,0,0-.87-3.35s0,0,0,0h0a5.1,5.1,0,0,0-1.21-1.56c-2-1.76-8.36-2.19-11.12,0s-5.08,8-6.8,8.65-2.71.19-3.89,1a3.69,3.69,0,0,0-1.42,2.23A14.12,14.12,0,0,1,66.52,11c-1,1.52-5.17,3.48-5.46,5.76a5.56,5.56,0,0,0,.69,3.11l.08.05a3.75,3.75,0,0,1,1.4,1.28,3.89,3.89,0,0,1,.9,1.7,5.54,5.54,0,0,1,.17.58,13.47,13.47,0,0,1,.2,1.42v.08a3.86,3.86,0,0,0,.78,3.39,2.38,2.38,0,0,0,.66.46l2.22,1.53a7.35,7.35,0,0,1-.42-1.75,8.21,8.21,0,0,1,0-1.22c.13-2.5.43-8.66.43-8.66-1.09-1-3.09-1.35-1.1-5.15a10,10,0,0,1,8.08-5.23A4.64,4.64,0,0,1,79,10.83a4.86,4.86,0,0,1-.71,1.57,21.77,21.77,0,0,0,4.36-2.51,15.81,15.81,0,0,1-1.94,2.17,12.61,12.61,0,0,0,4.61-2.85l1.81,5.55C88.34,11.42,87.15,6.55,87.15,6.55Z"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M15.75,34.16c-.63.12-2.94-3.08-5.18-4.93s-6.41-5.76-6.84-5.66a1.59,1.59,0,0,0-.91,1.62A10.19,10.19,0,0,0,7.48,30.6,19.19,19.19,0,0,1,12.57,36s-.76,1.28-1.29,1.33-3.51-2-5.89-2.9S.83,32.84.45,33s-.24,1,0,1.57,2.37,2.23,4.7,2.8c0,0,3.47,1.38,4.61,2.81,0,0-.14,1.42-.52,1.66s-3.23-.19-5-.43a8.88,8.88,0,0,0-4,.29c-.24.24,0,1,1.38,1.57A9.18,9.18,0,0,0,5,43.48c.29.05,5.47,1.67,6.08,2.05S14.42,50,16.37,51.2a7.22,7.22,0,0,0,4.75.6s3.13,17.53,4.65,24.5,7.35,14.19,12.42,14.51c0,0,4.56-1.77,4.81-11.15S40.09,67.3,40.09,67.3l-2,.66S29,62.55,26,49.38c0,0,2.28-4,2.38-5.37S27,39.6,26.59,35.86a26.16,26.16,0,0,1,.38-7c-.06-.44-2.34-.51-3,1.33s.32,5.13,0,5.77c-.23.46-.33,1.15-.77,1.25-.29.07-.77-.09-2.6-2.59-.67-.92-1.2-1.71-1.57-2.28"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M96.77,82.44a17.8,17.8,0,0,0-.92,1.81A16.13,16.13,0,0,0,95,86.76a57.25,57.25,0,0,0-.64,6.3,54.61,54.61,0,0,0,1.22,14.36,4.28,4.28,0,0,1,1.71,2.37v0a8,8,0,0,1-.1,2.55A9.48,9.48,0,0,1,98.46,114a1.45,1.45,0,0,1,.19.63,5.33,5.33,0,0,1-.48,2.22s-1.14,3-13,4a155.32,155.32,0,0,0-21.1,3.32,5.24,5.24,0,0,1,.59-4.18s-2-1.8-1.93-2.47,4.47-8.27,3.33-13.59-5.41-9.64-7.79-20c0,0-1.59-.54-1.68-1.3s.9-1,.9-1L57,78.83"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M58.47,49.38c.5,0,.7,1,.7,1a5.59,5.59,0,0,0,3.69,0,9.86,9.86,0,0,0,3.33-2s12,10.2,17.33,9.57c6-.71,1.77-7.31,1.77-7.31s3.79.74,5.81,1.21,2.79,0,2.79,0,1.21-1.79,2.79-.59"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M61.51,64.89"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M128.07,89.87c-1.08,2.42-2.2,4.87-3.35,7.33-.47,1-1,2-1.42,3a86.21,86.21,0,0,1-27.5.44L95,99.4c5-15,15.6-34.44,15.6-34.44a153,153,0,0,1,26.87,1.39l.51,1L134.27,76"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M129.18,87.69"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M132.88,79.67c.32-.09.64.52.85,1.19A2.29,2.29,0,0,1,132.11,84l-1,.25s.7.32.82.79-.66,1.52-1.93,1.78a6.16,6.16,0,0,1-4-.83c-.64-.57-.23-1.36.73-1.58,0,0-1.4-.31-1.34-1.28s3.26-2,6.66-1.7C132.08,81.43,132.45,79.8,132.88,79.67Z"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M135.06,74.55s1.71,1.59,1.71,2.68c0,1.69-2.76,2.5-6.85,3a2.24,2.24,0,0,1,0-1.74c.41-.9,2.57-2.17,4.35-2.46Z"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M71.22,20.72A6.32,6.32,0,0,1,73,17.64a14.64,14.64,0,0,1,4.62-2.82,3.56,3.56,0,0,1,.22,1.37s.24-.84.44-1.64a5.7,5.7,0,0,1,.23,2.34s-1.28.45-3.37,1A7,7,0,0,0,71.22,20.72Z"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M79.92,23.8c-.06.59-.86,1.64-2.57,1.64-1.52,0-3-.76-3-1.64a2.6,2.6,0,0,1,.22-1,4.18,4.18,0,0,1,1.68-1.91,2.74,2.74,0,0,1,1.65-.39C79.7,20.72,80,23.22,79.92,23.8Z"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M88.09,21.81c0,1.31-.54,2.3-1.53,2.28a1.05,1.05,0,0,1-.85-.33,1.7,1.7,0,0,1-.32-.69,3.89,3.89,0,0,1-.1-.4,12.36,12.36,0,0,1,.43-2.24,5.72,5.72,0,0,1,.25-.6,1.15,1.15,0,0,1,.59-.63C87.33,18.92,88.07,20.5,88.09,21.81Z"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M78.49,22.88a2,2,0,0,1-4,0v-.05a4.18,4.18,0,0,1,1.68-1.91l.3,0A2,2,0,0,1,78.49,22.88Z"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M77.88,22.88a1.37,1.37,0,1,1-1.37-1.37A1.37,1.37,0,0,1,77.88,22.88Z"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M87.24,21.81c0,1.09-.6,2-1.34,2a.58.58,0,0,1-.19,0,1.7,1.7,0,0,1-.32-.69,3.89,3.89,0,0,1-.1-.4,12.36,12.36,0,0,1,.43-2.24,5.72,5.72,0,0,1,.25-.6C86.68,19.89,87.24,20.75,87.24,21.81Z"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M86.68,21.81c0,.76-.41,1.37-.93,1.37a.69.69,0,0,1-.36-.11,3.89,3.89,0,0,1-.1-.4,12.36,12.36,0,0,1,.43-2.24h0C86.27,20.43,86.68,21.05,86.68,21.81Z"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M80,30.71s.12,1.29,2.5,2,4.4.28,5.14-.54a3.85,3.85,0,0,1-2.16,1.17,6.7,6.7,0,0,1-4.5-.84,3.61,3.61,0,0,1-1.31-1.58Z"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M19.68,33.12s-2-2.52-3.8-5.3-5-7.29-6.07-6.82-.14,3.33.86,5.14,2.28,2.47,2.85,3.42,2.23,4.6,2.23,4.6"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M67.84,30s-2.51-2.5-4.38-1.76c-.14.19-.29.37-.43.55a5,5,0,0,1-.81.65c-1.25,2.31.23,6.15,2.42,7.93s4.44,1.27,4.92-.8C69.56,36.59,70.21,31.92,67.84,30Z"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M67.76,33s-1.85-2.17-3.37-1.61-1.09,3-1.09,3,0-1.78,1-2,1.6,1,1.6,1-.53,0-.52,1.54,1.77,2.89,2.47,1.84S67.76,33,67.76,33Z"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M84.63,50.54a28.07,28.07,0,0,1-.69-5.77,23.06,23.06,0,0,1-7-1.33"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M64.64,86.76a7.85,7.85,0,0,1,4.92-2.54c3.43-.56,8.88.77,12.23.76,0,0-9.37,1.77-12.92,2.28S64.64,86.76,64.64,86.76Z"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
                opacity="0.62"
                style={{ mixBlendMode: "multiply" }}
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M99.72,171.26c-.41,1.4-.92,2.44-1.2,3.65-.44,1.9-1,9.3-1,9.3H84.26a106.44,106.44,0,0,0,1.9-11.71c.73-6.55-3.18-29.11-3.52-31.05"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
                opacity="0.62"
                style={{ mixBlendMode: "multiply" }}
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M138,67.3C118.8,64.83,111,66,111,66c-6.87,11.76-15.19,34.66-15.19,34.66L95,99.4c5-15,15.6-34.44,15.6-34.44a153,153,0,0,1,26.87,1.39Z"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M131.16,84.25a29.14,29.14,0,0,1-4.4.16,14.39,14.39,0,0,0,4.73,0Z"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M66.26,52.8a.56.56,0,0,0,0,.12A.79.79,0,0,1,66.26,52.8Z"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
                opacity="0.83"
                style={{ mixBlendMode: "multiply" }}
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M67.66,114.86s4.63.15,14.18-1.55c10.15-1.81,13.77-5.89,13.77-5.89a4.22,4.22,0,0,1,1.71,2.37s-8.62,3.64-15.48,4.53S69.05,115.27,67.66,114.86Z"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
                style={{ mixBlendMode: "soft-light" }}
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M77.55,119.75s5.75-.93,12.16-2.5S98.46,114,98.46,114s1.06,2.07-3.16,3.26S77.55,119.75,77.55,119.75Z"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
                style={{ mixBlendMode: "soft-light" }}
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M103.58,81.14l20.69,17-1,2a86.57,86.57,0,0,1-27.5.44L95,99.4s4.67-12.48,7.8-19Z"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
                opacity="0.5"
                style={{ mixBlendMode: "soft-light" }}
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M64,138.28a73.25,73.25,0,0,0,1,21.29Z"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
                opacity="0.62"
                style={{ mixBlendMode: "multiply" }}
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M85.29,50.59l-.66-.05a13.19,13.19,0,0,1,1.65,4c.29,1.8-.91,3-2.76,3.36,0,0,3-.17,3.37-2.23S85.29,50.59,85.29,50.59Z"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M81.54,19.1c-1-1.28-7.65-.07-9.53,2s.53,6.19,3.51,6.78c3.48.69,5.12-.44,6.08-1.91S82.42,20.26,81.54,19.1Zm0,6.16c-.78,2.17-3.67,2.9-6.09,2.25-1.5-.4-4-2.72-3.48-5.33s8.31-3.74,9.26-2.75C82,20.24,82.28,23.1,81.5,25.26Z"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M90.19,18.42c-.57-.93-3.82-.58-4.63,0-.53.38-.25,4.94,1.2,6.86a2,2,0,0,0,2.59.65C90.43,25.17,90.76,19.36,90.19,18.42Zm-.56,6a1.69,1.69,0,0,1-.9,1.26c-.79.28-1.59-.53-1.8-.74a4.34,4.34,0,0,1-1-2.44c-.44-2.17-.65-3.26,0-3.85.35-.35.88-.39,1.94-.46.7-.06,1.53-.11,1.93.39A1,1,0,0,1,90,19a6.59,6.59,0,0,1,.11,2.56A24.42,24.42,0,0,1,89.63,24.47Z"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M82.05,19.73a3.44,3.44,0,0,1,3.27-.31,1.55,1.55,0,0,1,.08-.66,7.87,7.87,0,0,0-3.78.22A6.56,6.56,0,0,1,82.05,19.73Z"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M71.65,21.63l-1.71.55-5.56,5.94a1.33,1.33,0,0,1,.68.13l5-5.27a2.65,2.65,0,0,1,1.4-.31A2.34,2.34,0,0,1,71.65,21.63Z"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M77.29,42.58"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M88.83,43.49a1.92,1.92,0,0,1-.57.48c-2.86,1.46-10.46,1.08-14.58-2.53A17.17,17.17,0,0,1,70,36.74"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M84.38,25.76a2.31,2.31,0,0,0,1.19,1.29c.54.22.89,0,1.31.37a1.41,1.41,0,0,1,.5,1.17,1.39,1.39,0,0,1-.44.91,1.44,1.44,0,0,1-1.23.34"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.circle
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                cx="84.89"
                cy="29.08"
                r="0.4"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
              <motion.path
                variants={pathVariants5}
                initial="hidden"
                animate="visible"
                d="M83.56,16a6.28,6.28,0,0,1-.21-1,6.48,6.48,0,0,1,0-1.21l.36.79c.11.24.2.43.27.55,0,0,0-.08,0-.12a13.06,13.06,0,0,0,0-1.54,5.37,5.37,0,0,1,.77.22,5.42,5.42,0,0,1,2.38,1.76,3,3,0,0,0-1.53-.38A3.09,3.09,0,0,0,83.56,16Z"
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="0.25"
              />
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};
